import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FinancedOffersListComponent from "./FinancedOffersListComponent";
import { getClientOffers, getFinancedOffers, getOfferPartners } from "../selectors";
import { loadClientOffers, updateFinancedOffersOnFolder, loadFolderOfferPartners } from "../actionCreators";
import { changeValueInArray } from "utils/functions";

const AddRemoveFinancedOffersContainer = ({
  documentId,
  siteId,
  actions,
  clientOffers,
  financedOffers,
  offerPartners,
  offerPartnersLoaded,
  history,
  clientId,
  isLoaded,
  isRemoveOffersMode
}) => {
  const [localClientOffers, setLocalClientOffers] = useState(
    clientOffers.map(offer => ({ ...offer, selected: false }))
  );
  const [localFinancedOffers, setLocalFinancedOffers] = useState(
    financedOffers.map(offer => ({ ...offer, selected: false }))
  );

  useEffect(() => {
    if (!isRemoveOffersMode) {
      actions.loadClientOffers(clientId);
      actions.loadFolderOfferPartners(documentId, siteId);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLoaded && clientOffers !== localClientOffers && !isRemoveOffersMode) {
      setLocalClientOffers(clientOffers.map(offer => ({ ...offer, selected: false })));
    }
  }, [clientOffers]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isLoaded && financedOffers !== localFinancedOffers && isRemoveOffersMode) {
      setLocalFinancedOffers(financedOffers.map(offer => ({ ...offer, selected: false })));
    }
  }, [financedOffers]); // eslint-disable-line react-hooks/exhaustive-deps

  const openClientOffer = (documentId, siteId) => () => {
    history.push(`/offers/${documentId}/${siteId}`);
  };

  const updateFinancedOffersOnFolder = () => () => {
    var selectedOffers;

    if (isRemoveOffersMode) {
      selectedOffers = localFinancedOffers.filter(x => x.selected);
    } else {
      selectedOffers = localClientOffers.filter(x => x.selected);
    }

    actions.updateFinancedOffersOnFolder(documentId, siteId, isRemoveOffersMode, selectedOffers);
    history.push(`/folders/${documentId}/${siteId}/generalData`);
  };

  const handleClientOfferSelection = offerId => event => {
    if (isRemoveOffersMode) {
      const res = changeValueInArray(localFinancedOffers, "offerId", offerId, "selected", event.target.checked);
      setLocalFinancedOffers(res);
    } else {
      const res = changeValueInArray(localClientOffers, "offerId", offerId, "selected", event.target.checked);
      setLocalClientOffers(res);
    }
  };

  const handleSelectAllClientOffers = () => () => {
    if (isRemoveOffersMode) {
      const res = localFinancedOffers.map(offer => ({ ...offer, selected: true }));
      setLocalFinancedOffers(res);
    } else {
      const res = localClientOffers.map(offer => ({ ...offer, selected: true }));
      setLocalClientOffers(res);
    }
  };

  return (
    <Fragment>
      {offerPartnersLoaded && (
        <FinancedOffersListComponent
          isRemoveOffersMode={isRemoveOffersMode}
          isSelectionMode={true}
          financedOffers={isRemoveOffersMode ? localFinancedOffers : localClientOffers}
          offerPartners={offerPartners}
          updateFinancedOffersOnFolder={updateFinancedOffersOnFolder}
          onAddFinancedOffers={function () {}}
          onRemoveFinancedOffers={function () {}}
          openFinancedOffer={openClientOffer}
          handleClientOfferSelection={handleClientOfferSelection}
          selectAllClientOffers={handleSelectAllClientOffers}
          isLoaded={isLoaded}
        />
      )}
    </Fragment>
  );
};

AddRemoveFinancedOffersContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  clientOffers: PropTypes.array.isRequired,
  financedOffers: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  offerPartners: PropTypes.array.isRequired,
  offerPartnersLoaded: PropTypes.bool,
  history: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  isRemoveOffersMode: PropTypes.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    clientOffers: getClientOffers(state, ownProps.documentId, ownProps.siteId),
    financedOffers: getFinancedOffers(state, ownProps.documentId, ownProps.siteId),
    isLoaded: this.isRemoveOffersMode
      ? state.currentFolder.financedOffers.isLoaded
      : state.currentFolder.clientOffers.isLoaded,
    offerPartners: getOfferPartners(state),
    offerPartnersLoaded: state.currentFolder.offerPartners.isLoaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadClientOffers, updateFinancedOffersOnFolder, loadFolderOfferPartners }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(AddRemoveFinancedOffersContainer));
